/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  chipNotStarted: {
    backgroundColor: '#FFE7E5 !important',
    color: '#D32F2F !important',
    fontSize: '12px',
    height: 24,
    borderRadius: '4px !important',
    border: 'none !important',
    '& .MuiChip-label': {
      padding: '0 8px',
      fontSize: '12px',
      fontWeight: 500
    }
  },
  chipInProgress: {
    backgroundColor: '#E1F5FE !important',
    color: '#1976D2 !important',
    fontSize: '12px',
    height: 24,
    borderRadius: '4px !important',
    border: 'none !important',
    '& .MuiChip-label': {
      padding: '0 8px',
      fontSize: '12px',
      fontWeight: 500
    }
  },
  chipCompleted: {
    backgroundColor: '#E8F5E8 !important',
    color: '#2E7D32 !important',
    fontSize: '12px',
    height: 24,
    borderRadius: '4px !important',
    border: 'none !important',
    '& .MuiChip-label': {
      padding: '0 8px',
      fontSize: '12px',
      fontWeight: 500
    }
  }
}));

const StatusChip = ({
  status,
  label,
  size = 'small',
  variant = 'filled',
  className = '',
  ...otherProps
}) => {
  const classes = useStyles();

  const getChipClass = (statusValue) => {
    const normalizedStatus = statusValue?.toLowerCase().replace(/\s+/g, '');

    switch (normalizedStatus) {
      case 'notstarted':
        return classes.chipNotStarted;
      case 'inprogress':
        return classes.chipInProgress;
      case 'completed':
        return classes.chipCompleted;
      default:
        return classes.chipNotStarted; // Default to not started
    }
  };

  const formatLabel = (statusValue, customLabel) => {
    if (customLabel) return customLabel;

    const normalizedStatus = statusValue?.toLowerCase().replace(/\s+/g, '');

    switch (normalizedStatus) {
      case 'notstarted':
        return 'Not Started';
      case 'inprogress':
        return 'In Progress';
      case 'completed':
        return 'Completed';
      default:
        return 'Not Started';
    }
  };

  const chipClass = getChipClass(status);
  const displayLabel = formatLabel(status, label);

  return (
    <Chip
      label={displayLabel}
      size={size}
      variant={variant}
      className={`${chipClass} ${className}`}
      {...otherProps}
    />
  );
};

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
  label: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['default', 'outlined', 'filled']),
  className: PropTypes.string
};

export default StatusChip;
